import repository from './index';  
const repositories = repository.repositories;

export default (key) => {   
    return repositories.hasOwnProperty(key) ? repositories[key] : null;
}